import { useState } from "react";
function useMultiInteraction() {
    const [pinned, setPinned] = useState();
    const [maximized, setMaximized] = useState();
    const handlePinned = (index) => {
        setMaximized(undefined);
        setPinned(pinned === index ? undefined : index);
    };
    const handleMaximized = (index) => {
        setPinned(undefined);
        setMaximized(maximized === index ? undefined : index);
    };
    const getPosition = (index) => {
        if (maximized !== undefined)
            return maximized === index ? "col-span-6" : "hidden";
        if (pinned !== undefined)
            return pinned === index ? "col-span-4 row-start-2" : "";
        const POSITIONS = {
            DEFAULT: "col-span-2",
            OFFSET: "col-start-2 col-span-2",
        };
        return index === 3 ? POSITIONS.OFFSET : POSITIONS.DEFAULT;
    };
    return { pinned, maximized, handlePinned, handleMaximized, getPosition };
}
export default useMultiInteraction;
